<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">连锁电商解决方案</div>
        <div class="line" />
        <div class="desc">
          连锁品牌全渠道全流程一体化经营解决方案，商家一个账号可实现多门店
          统一管理,线上线下大数据精准分析为多店管理提效，实现网店门店双增长
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="annoyance">
      <div class="title">连锁门店面临的烦恼</div>
      <div class="content">
        <div class="item">
          <img
            src="@/assets/images/chainE/chainE01.png"
            alt=""
          >
          <div>店铺各自创建商品，信息无法共享</div>
        </div>
        <div class="item">
          <img
            src="@/assets/images/chainE/chainE02.png"
            alt=""
          >
          <div>店铺自定义价格，商家无法统一管控</div>
        </div>
        <div class="item">
          <img
            src="@/assets/images/chainE/chainE03.png"
            alt=""
          >
          <div>多店铺共用仓库，无法共享库存</div>
        </div>
        <div class="item">
          <img
            src="@/assets/images/chainE/chainE04.png"
            alt=""
          >
          <div>员工管理混乱，账目理不清</div>
        </div>
      </div>
    </div>
    <div class="business">
      <div class="title">满足多种店铺类型经营需求</div>
      <div class="imgWrap">
        <img
          src="@/assets/images/chainE/chain_manage.png"
          alt=""
        >
      </div>
    </div>
    <div class="distribution">
      <div class="title">商家统一分发，店铺自行创建</div>
      <div class="imgWrap">
        <img
          src="@/assets/images/chainE/chain_distribution.png"
          alt=""
        >
      </div>
    </div>
    <div class="stock">
      <div class="title">商家库存共享，店铺库存独享</div>
      <div class="imgWrap">
        <img src="@/assets/images/chainE/chain_stock.png">
      </div>
    </div>
    <div class="staff">
      <div class="title">员工垂直管，组织明确分工</div>
      <div class="imgWrap">
        <img src="@/assets/images/chainE/chain_staff.png">
        <img src="@/assets/images/chainE/chain_org.png">
      </div>
    </div>
    <div class="chainSale">
      <div class="title">连锁营销，多店联动</div>
      <div class="imgWrap">
        <img src="@/assets/images/chainE/chain_sale01.png">
        <img src="@/assets/images/chainE/chain_sale02.png">
        <img src="@/assets/images/chainE/chain_sale03.png">
        <img src="@/assets/images/chainE/chain_sale04.png">
      </div>
    </div>
    <div class="data">
      <div class="title">数据统一管，账目清晰明了</div>
      <div class="imgWrap">
        <img src="@/assets/images/chainE/chain_data.png">
      </div>
    </div>
    <!-- 行业解决方案 -->
    <IndustrySolution />
    <CarouselItem title="连锁电商" />
    <ConsultForm info-sources="连锁电商" />
    <TryModal v-if="visible" :visible="visible" info-sources="连锁电商" @cancel="modalClose" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import IndustrySolution from './components/IndustrySolution'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.ChainE,
  components: {
    IndustrySolution,
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
h1 {
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  background: linear-gradient(90deg, rgba(88,140,236,1), rgba(106,106,207,1))
}
.content-center {
  .banner {
    background: url("~@/assets/images/chainE/chain_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 645px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        }
      }
    }
  }
  .title {
    font-size: 36px;
    text-align: center;
  }
  .annoyance {
    height: 518px;
    background: #fafafa;
    padding-top: 59px;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1120px;
      margin: 57px auto 0;
      .item {
        display: flex;
        flex-direction: column;
        img {
          width: 168px;
          height: 230px;
        }
        div {
          width: 172px;
          height: 83px;
          font-size: 20px;
          font-weight: 500;
          color: #595961;
          line-height: 28px;
        }
      }
    }
  }
  .business {
    height: 830px;
    padding: 60px 0 67px;
    .imgWrap {
      width: 1200px;
      height: 593px;
      margin: 59px auto 0;
      img {
        display: block;
        width: 1200px;
        height: 593px;
      }
    }
  }
  .distribution {
    height: 675px;
    padding: 57px 0 38px;
    background: #fafafa;
    .imgWrap {
      width: 947px;
      height: 456px;
      margin: 60px auto 0;
      img {
        display: block;
        width: 947px;
        height: 456px;
      }
    }
  }
  .stock {
    height: 709px;
    padding: 60px 0 95px;
    .imgWrap {
      width: 947px;
      height: 456px;
      margin: 38px auto 0;
      img {
        display: block;
        width: 947px;
        height: 456px;
      }
    }
  }
  .staff {
    background: #fafafa;
    padding: 46px 0 69px;
    .imgWrap {
      display: flex;
      justify-content: center;
      width: 570px;
      height: 450px;
      margin: 50px auto 0;
      img {
        display: block;
        width: 570px;
        height: 450px;
        margin-right: 60px;
      }
    }
  }
  .chainSale {
    padding: 60px 0 50px;
    .imgWrap {
      display: flex;
      justify-content: center;
      margin-top: 50px;
      img {
        display: inline-flex;
        width: 305px;
        height: 320px;
      }
    }
  }
  .data {
    background: #fafafa;
    padding-top: 60px;
    .imgWrap {
      margin-top: 40px;
    }
  }
}
</style>
